(function() {
    'use strict';
    angular.module('app').filter('mathFloor', function () {
        return function (number) {
            if (!number) {
                return number;
            } else {
                return Math.floor(number);
            }
        };
    });
}());